/* @flow */

import * as React from 'react';
import { css, names } from 'linaria';
import Flickity from 'flickity-imagesloaded';

import Colors from '../constants/Colors';

export function CarouselItem({ className, ...props }) {
  return <div className={names('CarouselItem', className)} {...props} />;
}

class Carousel extends React.Component<{
  children?: any,
  style?: any,
}> {
  flickity: Object;
  container: HTMLElement | null;

  componentDidMount() {
    this.flickity = new Flickity(this.container, {
      cellSelector: '.CarouselItem',
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      autoPlay: 5000,
      adaptiveHeight: true,
      imagesLoaded: true,
    });
  }

  componentWillUnmount() {
    this.flickity.destroy();
  }

  render() {
    let { children, style } = this.props;

    return (
      <div className={Styles.Carousel} style={style} ref={ref => (this.container = ref)}>
        {children}
      </div>
    );
  }
}

const Styles = {
  Carousel: css`
    margin-bottom: 30px;
    .flickity-viewport {
      transition: height 0.2s;
    }
    .flickity-page-dots {
      bottom: -30px;
    }
    .flickity-page-dots .dot {
      background-color: ${Colors.Yellow};
    }
  `,
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/ui/components/Carousel.js